import { call, put, select, takeEvery } from 'redux-saga/effects';
import { ROUTES } from '../../constants';
import history from '../../history';
import { QuizSessionService } from '../../services';
import * as types from '../types';
import { waitFor } from './general';


function* createQuizSession(action) {
  try {
    yield call(waitFor, state => state.token != null);
    const { token } = yield select((state) => state);
    const quizSessionService = yield call(() => new QuizSessionService(token));

    const quizSession = yield call([
      quizSessionService,
      quizSessionService.createQuizSession,
    ], action.payload);
    // console.log(quizSession);
    yield put({
      type: types.SET_QUIZ_SESSION_REDIRECT,
      payload: action.payload.redirect||ROUTES.EDITOR.MY_QUIZZES
    });
    history.push(ROUTES.QUIZ.WELCOME.replace(':code', quizSession.code));
  } catch (error) {
    console.error('createQuizSession error', error);
  }
}


export function* quizSessionSagas(){
  yield takeEvery(types.CREATE_QUIZ_SESSION, createQuizSession);

}

export default quizSessionSagas;
